/*  subscription-attr.js  – Baseline / Views
    Écrit dans le panier :
      ABO_STATUS = ABONNEMENT_EN_COURS
      ABO_TAGS   = SUB_1Y_PREPAID, SUB_2Y_PREPAID, …                        */
(() => {
  const DEBUG = true;                                  // ← passe à false en prod

  /** 1. ID de selling-plan  ➜  Tag interne **/
  const PLAN_MAP = {
    '689781473612': 'SUB_1Y_PREPAID',   // 1 an
    '689781506380': 'SUB_2Y_PREPAID'    // 2 ans  (mets l’ID réel si différent)
  };
  const GENERIC = 'ABONNEMENT_EN_COURS';

  /** 2. Helpers Ajax Shopify **/
  const getCart   = () => fetch('/cart.js').then(r => r.json());
  const setAttrib = a =>
    fetch('/cart/update.js', {
      method : 'POST',
      headers: { 'Content-Type':'application/json' },
      body   : JSON.stringify({ attributes: a })
    });

  /** 3. Récupère le tag d’un line-item **/
  const extractTag = item => {
    // a) allocation “classique”
    const idAlloc = item.selling_plan_allocation?.selling_plan_id;
    if (idAlloc && PLAN_MAP[idAlloc]) return PLAN_MAP[idAlloc];

    // b) properties éventuelles (PayWhirl _spid, etc.)
    if (item.properties) {
      for (const [k, v] of Object.entries(item.properties))
        if (/selling.*plan/i.test(k) && PLAN_MAP[v]) return PLAN_MAP[v];
    }

    // c) paramètre selling_plan=### dans l’URL du produit
    const m = /[?&]selling_plan=(\d+)/.exec(item.url);
    if (m && PLAN_MAP[m[1]]) return PLAN_MAP[m[1]];

    return null;
  };

  /** 4. Routine principale **/
  const tagCart = async () => {
    try {
      const { items, attributes = {} } = await getCart();

      const tags = [...new Set(items.map(extractTag).filter(Boolean))].sort();
      if (DEBUG) console.log('[subscription-attr] tags trouvés ⇒', tags);

      if (!tags.length) return;                         // aucun abo → on sort

      const tagStr = tags.join(', ');
      if (attributes.ABO_STATUS === GENERIC && attributes.ABO_TAGS === tagStr) {
        if (DEBUG) console.info('[subscription-attr] déjà à jour');
        return;
      }

      const merged = { ...attributes, ABO_STATUS: GENERIC, ABO_TAGS: tagStr };
      await setAttrib(merged);
      if (DEBUG) console.info('[subscription-attr] attributs mis à jour →', merged);

    } catch (err) {
      console.error('[subscription-attr] ERREUR', err);
    }
  };

  /** 5. Triggers **/
  document.addEventListener('DOMContentLoaded', tagCart);  // 1er affichage
  document.addEventListener('cart:updated',    tagCart);   // Baseline
  setInterval(() => document.visibilityState === 'visible' && tagCart(), 5000);
})();